import { scrambleTextAnim } from "../components/scramble-anim";
import gsap from "gsap";

let mblNavAnim: gsap.core.Timeline;
let navOpen = false;
let mblNav: HTMLElement;
let header: HTMLElement | null;
let toggle: HTMLElement;

export function initMblNav() {
    header = document.querySelector<HTMLElement>(".header");
    const nav = document.querySelector<HTMLElement>(".mbl-nav");
    const mblNavInner = document.querySelector(".mbl-nav__inner");
    const toggleEl = document.querySelector<HTMLElement>(".header__mbl-toggle");
    if (!header || !nav || !mblNavInner || !toggleEl) return;

    toggle = toggleEl;
    mblNav = nav;

    mblNavAnim = gsap
        .timeline({
            paused: true,
            defaults: {
                duration: 1.2,
                ease: "expo.inOut",
            },
        })
        .fromTo(mblNav, { display: "none" }, { display: "flex", duration: 0.01 })
        .fromTo(mblNav, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.6 })
        .fromTo(
            mblNavInner,
            { clipPath: "polygon(0 0, 100% 0, 100% 0%, 0 0%)" },
            {
                clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            },
            "<"
        )
        .fromTo(
            mblNavInner.children,
            { yPercent: 50, opacity: 0 },
            {
                yPercent: 0,
                opacity: 1,
                stagger: 0.3,
            },
            "<"
        );

    nav.setAttribute("aria-hidden", "true");
    navOpen = false;

    toggle.addEventListener("click", () => {
        if (!navOpen) {
            mblNav.setAttribute("aria-hidden", "false");
            mblNavAnim.duration(1.4);
            mblNavAnim.play();
            navOpen = true;

            setTimeout(() => {
                header?.classList.add("header--mbl-nav");
            }, 250);
            mblNav.classList.add("mbl-nav--open");
            scrambleTextAnim(toggle, "Close");
        } else hideMblNav();
    });

    mblNav.addEventListener("click", e => {
        if (e.target === mblNav) hideMblNav();
    });
}

export function hideMblNav() {
    mblNavAnim.duration(1.1);
    mblNavAnim.reverse();
    navOpen = false;
    mblNav.setAttribute("aria-hidden", "true");

    setTimeout(() => {
        mblNav.classList.remove("mbl-nav--open");

        setTimeout(() => {
            header?.classList.remove("header--mbl-nav");
        }, 250);
    }, 250);

    scrambleTextAnim(toggle, "Menu");
}
